import { MAX_WORK_PERIOD_DURATION_MS } from "@/helper/models/work-period-rules"

export function isWithinTrackingWindow(start: number, now = Date.now()): boolean {
  return Number.isFinite(start) && start <= now && now < start + MAX_WORK_PERIOD_DURATION_MS
}
